export enum ComponentType {
    General = 0,
    Custom = 1,
    Suplement = 2,
}